import Axios from "axios";

export const fetch_sms_sendings_by_order_id =
  (order_id, sms_sending_id = null) =>
  async (dispatch) => {
    try {
      const { data } = await Axios.get(
        `/api/v1/orders/${order_id}/sms_sendings/`
      );
      //   console.log({ data });
      if (!data.success) throw new Error("ERR");
      if (data.data) {
        dispatch({
          type: "SET_SMS_ITEMS",
          payload: data.data,
        });
      }
      if (sms_sending_id) {
        const find_item = data.data.find((e) => e.id == sms_sending_id);
        return {
          success: find_item?.sended_at ? true : false,
        };
      }
      return {
        success: false,
      };
    } catch (err) {
      console.log("ERROR: ", err);
      return {
        success: false,
      };
    }
  };
